import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import ProblemSection from "@/components/ProblemSection";
import WhatWeDo from "@/components/WhatWeDo";
import DifferentiatorSection from "@/components/DifferentiatorSection";
import WhoItsFor from "@/components/WhoItsFor";
import HowItWorks from "@/components/HowItWorks";
import LiveDemo from "@/components/LiveDemo";
import StatsSection from "@/components/StatsSection";
import FAQSection from "@/components/FAQSection";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <div className="relative" data-testid="landing-page">
      <Navbar />
      <HeroSection />
      <ProblemSection />
      <WhatWeDo />
      <DifferentiatorSection />
      <WhoItsFor />
      <HowItWorks />
      <LiveDemo />
      <StatsSection />
      <FAQSection />
      <FinalCTA />
      <Footer />
    </div>
  );
}
